import React, {useRef, useEffect} from "react";
import Header from "./Header";
import { Form, Alert } from "react-bootstrap";
import InputField from "../../../components/ConsultationTranscribedPrescriptions/InputField";
import RadioGroup from "../../../components/ConsultationTranscribedPrescriptions/RadioGroup";
import CheckboxGroup from "../../../components/ConsultationTranscribedPrescriptions/CheckboxGroup";
import FileUpload from "../../../components/ConsultationTranscribedPrescriptions/FileUpload";


const QuestionForm = ({
    form,
    questions,
    currentQuestion,
    currentIndex,
    currentAnswer,
    requiresExplanation,
    descriptionLabel,
    currentExplanation,
    apiError,
    isCurrentQuestionValid,
    isSubmit,
    onAnswer,
    onExplanationChange,
    onPrevious,
    onNext
    
}) => {
    const formTopRef = useRef(null);
    useEffect(() => {
        // Scroll to the top of the form
        if (formTopRef.current) {
            formTopRef.current.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
            });
        }
        
        // Alternative: Scroll to top of window
        // window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [currentIndex]);
    return (
        <div className="" ref={formTopRef}>
            {apiError && (
                <Alert variant="danger" className="mb-4">
                    {apiError}
                </Alert>
            )}

            {/* <div className="d-flex align-items-center mb-4">
                <span className="badge bg-primary me-3">
                    Question {currentIndex + 1} of {questions.length}
                </span><br />
                <h5 className="mb-0 fw-bold">{form?.title} Assessment</h5>
            </div> */}

            <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="fw-semibold">Progress</div>
                    <div className="text-muted small">
                        Question {currentIndex + 1} of {questions.length}
                    </div>
                </div>
                <div className="progress" style={{ height: "10px" }}>
                    <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        style={{
                            width: `${((currentIndex + 1) / questions.length) * 100}%`
                        }}
                        aria-valuenow={currentIndex + 1}
                        aria-valuemin={0}
                        aria-valuemax={questions.length}
                    ></div>
                </div>
            </div>

            <Form.Group controlId={`formStep${currentQuestion.step}`}>
                <h5 className="mb-4">{currentQuestion.title}</h5>
                {currentQuestion.description && (
                    <div
                        className="text-muted mb-4"
                        dangerouslySetInnerHTML={{ __html: currentQuestion.description }}
                    />
                )}


                {currentQuestion.inputType === "text" && (
                    <InputField
                        label=""
                        name={currentQuestion._id}
                        value={currentAnswer.description || ""}
                        onChange={(e) =>
                            onAnswer(currentQuestion._id, null, e.target.value, "")
                        }
                        placeholder="Type your answer here..."
                        className="form-control-lg"
                    />
                )}

                {currentQuestion.inputType === "radio" && (
                    <RadioGroup
                        name={currentQuestion._id}
                        options={currentQuestion.options.map((opt) => ({
                            label: opt.optionText,
                            value: opt._id,
                            description: opt.description,
                        }))}
                        selectedValue={currentAnswer.options[0] || ""}
                        onChange={(value) =>
                            onAnswer(currentQuestion._id, value, "", "")
                        }
                    />
                )}
                {currentQuestion.inputType === "select" && (
                    <RadioGroup
                        name={currentQuestion._id}
                        options={currentQuestion.options.map((opt) => ({
                            label: opt.optionText,
                            value: opt._id,
                            description: opt.description,
                        }))}
                        selectedValue={currentAnswer.options[0] || ""}
                        onChange={(value) =>
                            onAnswer(currentQuestion._id, value, "", "")
                        }
                    />
                )}

                {currentQuestion.inputType === "checkbox" && (
                    <CheckboxGroup
                        label=""
                        name={currentQuestion._id}
                        options={currentQuestion.options.map((opt) => ({
                            label: opt.optionText,
                            value: opt._id,
                            description: opt.description,
                        }))}
                        selectedValues={currentAnswer.options || []}
                        onChange={(value) =>
                            onAnswer(currentQuestion._id, value, "", "")
                        }
                    />
                )}
                {currentQuestion.inputType === "file" && (
                    <FileUpload
                        name={currentQuestion._id}
                        value={currentAnswer.file || null}
                        onChange={(file) => onAnswer(currentQuestion._id, null, "", file)}
                        accept="image/*"
                        className="mt-3"
                    />
                )}

                {requiresExplanation && (
                    <div className="mt-4">
                        <Form.Label className="fw-semibold">
                            {descriptionLabel}
                        </Form.Label>
                        <textarea
                            className="form-control"
                            rows="3"
                            value={currentExplanation.text}
                            placeholder="Type your explanation here..."
                            onChange={(e) =>
                                onExplanationChange(
                                    currentQuestion._id,
                                    e.target.value
                                )
                            }
                        ></textarea>
                    </div>
                )}
            </Form.Group>

            <div className="d-flex justify-content-between mt-5 pt-3 gap-10">
                <button
                    type="button"
                    className="btncust"
                    onClick={onPrevious}
                >
                    Back
                </button>

                <button
                    type="button"
                    className={`btncust ${isCurrentQuestionValid ? "activebg" : "btn-disable"
                        }`}
                    onClick={onNext}
                    disabled={!isCurrentQuestionValid}
                >
                    Next
                </button>

                {/* {currentIndex < questions.length - 1 ? (
                    <button
                        type="button"
                        className={`btncust ${isCurrentQuestionValid ? "activebg" : "btn-disable"
                            }`}
                        onClick={onNext}
                        disabled={!isCurrentQuestionValid}
                    >
                        Next
                    </button>
                ) : (
                    <button
                        type="button"
                        className={`btncust ${isCurrentQuestionValid ? "activebg" : "btn-disable"
                            }`}
                        onClick={onSubmit}
                        disabled={!isCurrentQuestionValid || isSubmit}
                    >
                        {isSubmit ? (
                            <>
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Submitting...
                            </>
                        ) : (
                            "Submit"
                        )}
                    </button>
                )} */}
            </div>
        </div>
    );
};

export default QuestionForm;
